import { render, staticRenderFns } from "./LKMunMehExpertView.vue?vue&type=template&id=1b364db4&"
import script from "./LKMunMehExpertView.vue?vue&type=script&lang=js&"
export * from "./LKMunMehExpertView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports